import qs from 'query-string';
import { get, post, del } from './baseApi';

export const VetApi = {
    fetch: (query) => get(`/vets?${qs.stringify(query)}`),
    create: (data) => post('/vets', data),
    check: (code) => get(`/vets/${code}/check`),
    delete: (id) => del(`/vets/${id}`),
};
